import { TabItemProps } from "./navigation-context";

export const GLOBAL_NAMESPACE = 'bim.';
export const AUTHORIZATION = GLOBAL_NAMESPACE + 'authorization';
export const REMEMBER_USERNAME = GLOBAL_NAMESPACE + 'username';
export const REMEMBER_PASSWORD = GLOBAL_NAMESPACE + 'password';
export const REMEMBER_TAG = GLOBAL_NAMESPACE + 'remember';
export const PROJECT_UUID = GLOBAL_NAMESPACE + 'project_uuid';
export const PROJECT_NAME = GLOBAL_NAMESPACE + 'project_name';
// export const MODEL_UUID = GLOBAL_NAMESPACE + 'model_uuid';
// export const BRANCH_UUID = GLOBAL_NAMESPACE + 'branch_uuid';
// export const BRANCH_LEVEL = GLOBAL_NAMESPACE + 'branch_level';
export const USER_UUID = GLOBAL_NAMESPACE + 'user_uuid';
export const USER_NAME = GLOBAL_NAMESPACE + 'user_name';
export const USER_META = GLOBAL_NAMESPACE + 'user_meta';
export const USER_MOBILE = GLOBAL_NAMESPACE + 'user_mobile';
export const AVATAR = GLOBAL_NAMESPACE + 'avatar';
export const AUTHORITY = GLOBAL_NAMESPACE + 'authority';
// export const SELECTED_PANEL = GLOBAL_NAMESPACE + 'selected_panel';
// export const SELECTED_MAJOR = GLOBAL_NAMESPACE + 'selected_major';
export const FILTER = GLOBAL_NAMESPACE + 'FILTER';

export const TABS = GLOBAL_NAMESPACE + "TABS";

export const AXIS_NET_GRID = GLOBAL_NAMESPACE + "AXIS_NET_GRID";

// 记录当前打开的专业，记录专业uuid
export const ACTIVE_MAJOR = GLOBAL_NAMESPACE + "ACTIVE_MAJOR";
// 记录每个专业最后打开的sidebarkey和toolkey
export const MAJOR_KEYS = GLOBAL_NAMESPACE + "MAJOR_KEYS";
// 记录在每个sidebarkey下打开的页签，和激活的页签
export const SIDEBAR_TABS = GLOBAL_NAMESPACE + "SIDEBAR_TABS";
// 记录每个sidebarPanel中的状态
export const SIDEBARPANEL_STORE = GLOBAL_NAMESPACE + "SIDEBAR_STORE";
// 记录每个toolPanel中的状态
export const TOOLPANL_STORE = GLOBAL_NAMESPACE + "TOOL_STORE";
// 记录一级状态组的打开
export const ACTIVE_STATUS_UUID = GLOBAL_NAMESPACE + "ACTIVE_STATUS_UUID";

class LocalStore {

    public get(key: string) {
        return JSON.parse(localStorage.getItem(key) || 'null') || null;
    }

    public set(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public remove(key: string): void {
        localStorage.removeItem(key);
    }

    get token(): string {
        return this.get(AUTHORIZATION) || '';
    }

    set token(value: string) {
        this.set(AUTHORIZATION, value);
    }

    get userUuid(): string {
        return this.get(USER_UUID) || '';
    }
    set userUuid(value: string) {
        this.set(USER_UUID, value);
    }

    get name(): string {
        return this.get(USER_NAME) || '';
    }
    set name(value: string) {
        this.set(USER_NAME, value);
    }

    get mobile(): string {
        return this.get(USER_MOBILE) || '';
    }
    set mobile(value: string) {
        this.set(USER_MOBILE, value);
    }

    get password(): string {
        return this.get(REMEMBER_PASSWORD) || '';
    }
    set password(value: string) {
        this.set(REMEMBER_PASSWORD, value);
    }

    get projectUuid(): string {
        return this.get(PROJECT_UUID) || '';
    }
    set projectUuid(value: string) {
        this.set(PROJECT_UUID, value);
    }

    get projectName(): string {
        return this.get(PROJECT_NAME) || '';
    }
    set projectName(value: string) {
        this.set(PROJECT_NAME, value);
    }

    get tabItemList() {
        return this.get(TABS)
    }

    set tabItemList(value: { key: string, value: string, closable?: boolean }[]) {
        this.set(TABS, value)
    }

    get axisNetGrid() {
        return this.get(AXIS_NET_GRID)
    }

    set axisNetGrid(value: any) {
        this.set(AXIS_NET_GRID, value)
    }

    get activeMajor() {
        return this.get(ACTIVE_MAJOR)
    }

    set activeMajor(value: string) {
        if (!value) {
            value = "project";
        }
        this.set(ACTIVE_MAJOR, value)
    }

    get majorKeys() {
        return this.get(MAJOR_KEYS)
    }

    set majorKeys(value: { [key: string]: { sidebarKey: string, toolKey: string } }) {
        this.set(MAJOR_KEYS, value)
    }

    get sidebarTabs() {
        return this.get(SIDEBAR_TABS)
    }

    set sidebarTabs(value: { [key: string]: { tabs: TabItemProps[], activeTabKey: string } }) {
        this.set(SIDEBAR_TABS, value)
    }

    get sidebarPanelStore() {
        return this.get(SIDEBARPANEL_STORE)
    }

    set sidebarPanelStore(value: { [key: string]: { [key: string]: any } }) {
        this.set(SIDEBARPANEL_STORE, value)
    }

    get toolPanelStore() {
        return this.get(TOOLPANL_STORE)
    }

    set toolPanelStore(value: { [key: string]: { [key: string]: any } }) {
        this.set(TOOLPANL_STORE, value)
    }

    get activeStatusUuid() {
        return this.get(ACTIVE_STATUS_UUID)
    }

    set activeStatusUuid(value: string) {
        this.set(ACTIVE_STATUS_UUID, value)
    }

    public setAuthority(types: number[]) {
        if (types == null) {
            this.remove(AUTHORITY);
            return;
        }
        this.set(AUTHORITY, types);
    }

    public getAuthority() {
        return this.get(AUTHORITY);
    }

    public getUser() {
        return this.get(USER_META);
    }

    public setFilter(value: { [key: number]: string[] } = {}) {
        if (value == null) {
            this.remove(FILTER);
            return;
        }
        this.set(FILTER, value);
    }

    public getFilter() {
        return this.get(FILTER);
    }

    // public getTabItemList() {
    //     return this.get(TABS)
    // }

    // public setTabItemList(value: { key: string, value: string, closable?: boolean }[]) {
    //     return this.set(TABS, value)
    // }

    // 根据major获得当前激活的sidebarKey
    public getSidebarKeyByMajor(major: string) {
        const majorKeys = this.get(MAJOR_KEYS);
        if (majorKeys == null) return null;
        const keys = majorKeys[major];
        if (keys == null) return null;
        return keys.sidebarKey;
    }

    // 根据major获得当前激活的toolKey
    public getToolKeyByMajor(major: string) {
        const majorKeys = this.get(MAJOR_KEYS);
        if (majorKeys == null) return null;
        const keys = majorKeys[major];
        if (keys == null) return null;
        return keys.toolKey;
    }

    // 设置当前激活的sidebarKey
    public setActiveSidebarKey(value: string) {
        const major = this.get(ACTIVE_MAJOR);
        let majorKeys = this.get(MAJOR_KEYS);
        if (majorKeys == null) {
            majorKeys = {};
            majorKeys[major] = {};
        }
        let keys = majorKeys[major];
        if (keys == null) {
            majorKeys[major] = {};
            keys = majorKeys[major];
        }
        keys['sidebarKey'] = value;
        return this.set(MAJOR_KEYS, majorKeys);
    }
    // 设置当前激活的toolKey
    public setActiveToolKey(value: string) {
        const major = this.get(ACTIVE_MAJOR);
        let majorKeys = this.get(MAJOR_KEYS);
        if (majorKeys == null) {
            majorKeys = {};
            majorKeys[major] = {};
        }
        let keys = majorKeys[major];
        if (keys == null) {
            keys = {};
        }
        keys['toolKey'] = value;
        return this.set(MAJOR_KEYS, majorKeys);
    }

    // 获得当前激活的sidebarKey
    public getActiveSidebarKey() {
        const major = this.get(ACTIVE_MAJOR);
        return this.getSidebarKeyByMajor(major);
    }

    // 获得当前激活的toolKey
    public getActiveToolKey() {
        const major = this.get(ACTIVE_MAJOR);
        return this.getToolKeyByMajor(major);
    }

    // 根据sidebarkey获得页签列表
    public getTabsBySidebarKey(sidebarKey: string) {
        const sidebarTabs = this.get(SIDEBAR_TABS);
        if (sidebarTabs == null) return [];
        const item = sidebarTabs[sidebarKey];
        if (item == null) return [];
        return item.tabs;
    }

    // 根据sidebarkey获得激活的页签
    public getActiveTabKeyBySidebarKey(sidebarKey: string) {
        const sidebarTabs = this.get(SIDEBAR_TABS);
        if (sidebarTabs == null) return null;
        const item = sidebarTabs[sidebarKey];
        if (item == null) return null;
        return item.activeTabKey;
    }

    // 获得当前显示的页签
    public getCurrentTabs() {
        const sidebarTabs = this.get(SIDEBAR_TABS);
        if (sidebarTabs == null) return [];
        const sidebarKey = this.getActiveSidebarKey();
        const item = sidebarTabs[sidebarKey];
        if (item == null) return [];
        return item.tabs;
    }

    // 获得当前激活的页签
    public getActiveTabKey() {
        const sidebarTabs = this.get(SIDEBAR_TABS);
        if (sidebarTabs == null) return [];
        const sidebarKey = this.getActiveSidebarKey();
        const item = sidebarTabs[sidebarKey];
        if (item == null) return null;
        return item.activeTabKey;
    }

    // 给当前激活的sidebarkey对应的页签赋值
    public setCurrentTabs(value: TabItemProps[]) {
        let sidebarTabs = this.get(SIDEBAR_TABS);
        if (sidebarTabs == null) {
            sidebarTabs = {};
        }
        const sidebarKey = this.getActiveSidebarKey();
        let item = sidebarTabs[sidebarKey];
        if (item == null) {
            item = {};
            sidebarTabs[sidebarKey] = item;
        }
        item['tabs'] = value;
        return this.set(SIDEBAR_TABS, sidebarTabs);
    }

    // 给当前激活的sidebarkey对应的激活页签赋值
    public setCurrentActiveTabKey(value: string) {
        let sidebarTabs = this.get(SIDEBAR_TABS);
        if (sidebarTabs == null) {
            sidebarTabs = {};
        }
        const sidebarKey = this.getActiveSidebarKey();
        let item = sidebarTabs[sidebarKey];
        if (item == null) {
            item = {};
        }
        item['activeTabKey'] = value;
        return this.set(SIDEBAR_TABS, sidebarTabs);
    }

    /**
     * 设置侧边栏状态
     * @param key 
     * @param value 
     */
    public setSidebarStatus(key: string, value: {}) {
        let statusDict = this.get(SIDEBARPANEL_STORE);
        if (statusDict == null) {
            statusDict = {};
        }
        const sidebarKey = key;
        statusDict[sidebarKey] = { ...value }
        return this.set(SIDEBARPANEL_STORE, statusDict);
    }

    /**
     * 获取侧边栏暂存状态
     * @param key 
     * @returns 
     */
    public getSidebarStatus(key: string) {
        const status = this.get(SIDEBARPANEL_STORE);
        if (status == null) return {};
        return status[key] || {};
    }

    /**
     * 设置工具面板状态
     * @param key 
     * @param value 
     * @returns 
     */
    public setToolPanelStatus(key: string, value: {}) {
        let statusDict = this.get(TOOLPANL_STORE);
        if (statusDict == null) {
            statusDict = {};
        }
        const toolKey = key;
        statusDict[toolKey] = { ...value }
        return this.set(TOOLPANL_STORE, statusDict);
    }

    /**
     * 获取工具面板状态
     * @param key 
     * @returns 
     */
    public getToolPanelStatus(key: string) {
        const status = this.get(TOOLPANL_STORE);
        if (status == null) return {};
        return status[key] || {};
    }

    public getActiveStatusUuid() {
        const uuid = this.get(ACTIVE_STATUS_UUID)
        return uuid
    }

    public setActiveStatusUuid(value: string) {
        this.set(ACTIVE_STATUS_UUID, value)
    }

    clearProjectInfo() {
        // this.remove(AUTHORITY);
        // this.remove(SELECTED_PANEL);
        this.remove(PROJECT_UUID);
        this.remove(PROJECT_NAME);
        // this.remove(BRANCH_UUID);
        // this.remove(BRANCH_LEVEL);
        // this.remove(MODEL_UUID);
        this.remove(FILTER);
        this.remove(TABS);
        this.remove(ACTIVE_MAJOR);
        this.remove(MAJOR_KEYS);
        this.remove(SIDEBAR_TABS);
        this.remove(SIDEBARPANEL_STORE);
        this.remove(TOOLPANL_STORE);
        this.remove(ACTIVE_STATUS_UUID)
    }

    clear() {
        this.remove(AUTHORIZATION);
        this.remove(PROJECT_UUID);
        this.remove(PROJECT_NAME);
        // this.remove(BRANCH_UUID);
        // this.remove(BRANCH_LEVEL);
        // this.remove(MODEL_UUID);
        this.remove(USER_UUID);
        this.remove(USER_NAME);
        this.remove(USER_META);
        this.remove(AUTHORITY);
        // this.remove(SELECTED_PANEL);
        // this.remove(SELECTED_MAJOR);
        this.remove(FILTER);
        this.remove(TABS);
        this.remove(ACTIVE_MAJOR);
        this.remove(MAJOR_KEYS);
        this.remove(SIDEBAR_TABS);
        this.remove(SIDEBARPANEL_STORE);
        this.remove(TOOLPANL_STORE);
        this.remove(ACTIVE_STATUS_UUID)
    }
}

export default new LocalStore();